function showCanals (obj) {
  if (obj.hasClass('onlyHd')) {

    obj.closest('.tv-list__header').next('.tv-list__items').children('.tv-list__item').show();
    obj.html('Только HD-каналы');

    obj.removeClass('onlyHd');

  } else {

    obj.closest('.tv-list__header').next('.tv-list__items').children('.tv-list__item').hide();
    obj.html('Все каналы');

    $('.tv-list__item--hd').show();

    obj.addClass('onlyHd');
  }
}

$('.showCanals').click(function (e) {
  e.preventDefault();

  // показать все или только hd-каналы в зависимости от состояния, передаем текущий клик (obj)
  showCanals($(this));
});



// WEBPACK FOOTER //
// ./app/blocks/tv-list/tv-list.js